<template>
  <!-- :style="{backgroundImage:'url('+textupdate.photo+')'}" => 此寫法才能動態改背景圖並渲染在畫面上 -->
  <div>
    <div
      class="HomePageBackground"
      :style="{ backgroundImage: 'url(' + textupdate.photo + ')' }"
    >
      <sidebar></sidebar>
      <!-- <a href="#" class="box" @click="GoToLogin"></a> -->

      <a style="cursor: default" @click="GoToLogin" class="box" href="#"></a>

      <div class="Text_position">
        <div class="title-Block" @dblclick="ButtonEvent">
          <h2
            style="white-space: pre-line"
            class="HomeTitle text-lg-h2 text-xl-h2"
            v-show="!DisplaySwitch"
          >
            {{ textupdate.title }}
          </h2>
        </div>

        <div class="pt-5 pb-5 desc-Block" @dblclick="ButtonEvent">
          <p
            class="text-lg-h6 text-xl-h5"
            style="white-space: pre-line"
            v-show="!DisplaySwitch"
          >
            {{ textupdate.desc }}
          </p>
        </div>

        <a href="https://pescadores.ezhotel.com.tw/3">

        <div class="Btn">
          
          <v-btn
            color="#F29100"
            elevation="5"
            large
            raised
            class="BookBtn white--text"
            >Book Now</v-btn
          >
        </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import fortest from "@/components/login.vue";
import sidebar from "@/components/The_Sidebar.vue";

export default {
  components: {
    sidebar, //Navber
    fortest, //Footer
  },
  data: () => ({
    lineshow: false,
    showMenu: false,
    hidden: true,
    ChangeButtonOpen: false,
    dialog: false,
    ErrorDialog: false,
    isTransform: true,
    image: "",
    count: 0,
    // 雙擊SHOW input hide文字欄位
    DisplaySwitch: false,

    lineshow: false,

    //API參數
    textupdate: {
      title: "",
      desc: "",
      button: "asdasdasd",
      photo: "",
    },

    //<!-- Tool bar -->
    direction: "top",
    fab: true,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: false,
    bottom: true,
    left: true,
    transition: "scale-transition",
  }),

  //網頁一渲染先把/show 資料callback回來渲染在畫面上
  created() {
    let vm = this;
    let str = localStorage.getItem("LoginStatus");
    let token = localStorage.getItem("Token");

    if (str == 201) {
      vm.ChangeButtonOpen = true;
    } else if (str == "") {
      vm.ChangeButtonOpen = false;
    }

    let axios = require("axios");
    let config = {
      method: "post",
      url: "https://think-x-tech.synology.me/hotel_system/public/api/index/show",
      headers: {
        Authorization: "Bearer 267|2cEoJMpGw63gFpsaK8crj6sy6kxPPmdQCCgtWKFF",
      },
    };
    axios(config)
      .then(function (response) {
        vm.textupdate.title = response.data.title;
        vm.textupdate.desc = response.data.desc;
        vm.textupdate.button = response.data.button;
        vm.textupdate.photo =
          "https://think-x-tech.synology.me/hotel_system/" + response.data.path;
      })
      .catch(function (error) {
        console.log(error);
        alert("系統錯誤，請聯繫IT人員協助處裡! ! ! !");
      });
  },

  methods: {
    ButtonEvent() {
      let str = localStorage.getItem("LoginStatus");
      // 登入狀態時雙擊效果才會出來
      if (str) {
        this.DisplaySwitch = true;
      } else {
        this.DisplaySwitch = false;
      }
    },

    GoToLogin() {
      let Times = this.count++;
      console.log(Times);
      if (Times == 9) {
        alert("即將進入到登入畫面");
        let getAtag = document.querySelector(".HomePageBackground > a");
        console.log(getAtag);
        getAtag.href = "http://www2.pescadoresresort.com/jia_chi_edit/#/login";
      }
    },

    //登出時將 status 刪除
    Logout() {
      localStorage.removeItem("LoginStatus");
      localStorage.removeItem("Token");
    },
  },
};
</script>

<style scoped lang="scss">
$main_color: #ffffff;

.HomePageBackground {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100vw;
  height: 100vh;
  h1,
  h2,
  h3,
  h4,
  h5,
  h5,
  p {
    text-align: left;
    color: $main_color;
  }
  .Text_position {
    position: absolute;
    top: 35%;
    right: 10%;
    .BookBtn {
      padding: 0 30%;
    }
  }
  .HomeTitle {
    font-weight: 400;
  }
}

.box {
  background-color: chartreuse;
  width: 100px;
  height: 50px;
  position: fixed;
  right: 0;
  z-index: 1;
  opacity: 0;
}

.ChangeButton {
  position: fixed;
  bottom: 5%;
  left: 3%;
  display: flex;
  flex-direction: column;
}
.text-input {
  width: 25vw;
}
.level-line {
  position: relative;
  top: 47%;
  left: 20%;
  width: 60%;
  background-color: #9e9e9e57;
}
.straight-line {
  position: relative;
  top: 7%;
  left: 50%;
  height: 60%;
  background-color: #80808066;
}

//更改image圖片位置的input
.portrait.v-card {
  position: absolute;
  right: 10%;
  bottom: 10%;
}
.file-input {
  height: 100vh;
  width: 100vw;
}

@media screen and (min-width: 960px) and (max-width: 1264px) {
  .HomePageBackground {
    .Text_position {
      width: 100vw;
      top: 35%;
      right: 0%;
      bottom: 0%;
      left: 0%;
      .HomeTitle {
        font-weight: bold;
        font-size: 50px;
        text-align: center;
      }
      P {
        font-size: 30px;
        text-align: center;
      }
      .Btn {
        display: flex;
        justify-content: center;
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 960px) {
  .HomePageBackground {
    .Text_position {
      width: 100vw;
      top: 35%;
      right: 0%;
      bottom: 0%;
      left: 0%;

      .HomeTitle {
        font-weight: bold;
        font-size: 50px;
        text-align: center;
      }
      P {
        font-size: 30px;
        text-align: center;
      }
      .Btn {
        display: flex;
        justify-content: center;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .HomePageBackground {
    .Text_position {
      width: 70%;
      top: 30%;
      .HomeTitle {
        font-weight: bold;
        font-size: 50px;
        text-align: left;
      }
      P {
        font-size: 20px;
        text-align: left;
      }
    }
  }
}

@media screen and (max-width: 320px) {
  .HomePageBackground {
    .Text_position {
      width: 70%;
      top: 30%;
      .HomeTitle {
        font-weight: bold;
        font-size: 30px;
        text-align: left;
      }
      P {
        font-size: 20px;
        text-align: left;
      }
    }
  }
}
</style>
